import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const ImageSlider = forwardRef(function ImageSlider({ images = [], hideControls = false, fit = 'contain', onChange }, ref) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent((c) => (c === 0 ? images.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === images.length - 1 ? 0 : c + 1));
  const goTo = (i) => setCurrent(i);

  useImperativeHandle(ref, () => ({ prev, next, goTo }));

  useEffect(() => { onChange?.(current); }, [current, onChange]);

  if (!images.length) return null;

  return (
    <div className={`img-slider img-slider--${fit}`}>
      <div className="img-slider__track">
        {images.map((img, i) => (
          <div
            key={i}
            className="img-slider__slide"
            style={{ opacity: i === current ? 1 : 0, pointerEvents: i === current ? 'auto' : 'none' }}
          >
            <img src={img.src} alt={img.alt || `Slide ${i + 1}`} loading="lazy" />
          </div>
        ))}

        {!hideControls && images.length > 1 && (
          <>
            <button onClick={prev} className="img-slider__arrow img-slider__arrow--prev" aria-label="Previous image">←</button>
            <button onClick={next} className="img-slider__arrow img-slider__arrow--next" aria-label="Next image">→</button>
            <div className="img-slider__dots">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`img-slider__dot${i === current ? ' img-slider__dot--active' : ''}`}
                  aria-label={`Go to image ${i + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
});

export default ImageSlider;
